import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref, watch, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import Card from '@/views/dashboard/_components/card/card.vue'
import TerminalViewTable from './_components/terminal-view-table.vue'
import RiskViewTable from './_components/risk-view-table.vue'
import VirusSummaryCards from './_components/virus-summary-cards/virus-summary-cards.vue'
import VirusDistributionChart from './_components/virus-distribution-chart/virus-distribution-chart.vue'
import VirusTrendChart from './_components/virus-trend-chart/virus-trend-chart.vue'
import { TableViewMode } from '@/views/dashboard/_enum/table-view-mode'
import type { FetchOptions } from './loaris-trojan-remover.service'
import { useRolePermStore } from '@/services/role-perm.service'

type RiskDrawerChartPreset = {
  risk_type?: number
  /** 病毒分布饼图 slug ，与 getThreatTagTitle 同源 */
  threat_tag?: string
  start_time?: number
  end_time?: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'loaris-trojan-remover',
  setup(__props) {

const { cmRolePermMapFe } = useRolePermStore()
const terminalDrawerVisible = ref(false)
const terminalDrawerPatch = ref<Partial<FetchOptions>>({})
const terminalDrawerKey = ref(0)

const riskDrawerVisible = ref(false)
const riskDrawerKey = ref(0)
const riskDrawerChartPreset = ref<RiskDrawerChartPreset | null>(null)
/** 统计卡片：RemoverLogReq.handle_status，1 未处理 / 2 已处理 / 4 已信任 */
const riskDrawerHandleStatus = ref<number | undefined>(undefined)

const terminalTableRef = ref()
const riskTableRef = ref()
const route = useRoute()

function openTerminalDrawerViewAll () {
  terminalDrawerPatch.value = {}
  terminalDrawerKey.value += 1
  terminalDrawerVisible.value = true
}

function onVirusSummaryOpenTerminal (patch: Partial<FetchOptions>) {
  terminalDrawerPatch.value = patch
  terminalDrawerKey.value += 1
  terminalDrawerVisible.value = true
}

function onVirusSummaryOpenRisk (handle_status: number) {
  riskDrawerChartPreset.value = null
  riskDrawerHandleStatus.value = handle_status
  riskDrawerKey.value += 1
  riskDrawerVisible.value = true
}

function openRiskDrawerViewAll () {
  riskDrawerChartPreset.value = null
  riskDrawerHandleStatus.value = undefined
  riskDrawerKey.value += 1
  riskDrawerVisible.value = true
}

function onVirusDistributionSliceClick (payload: RiskDrawerChartPreset) {
  const next = { ...payload }
  delete next.start_time
  delete next.end_time
  riskDrawerHandleStatus.value = undefined
  riskDrawerChartPreset.value = next
  riskDrawerKey.value += 1
  riskDrawerVisible.value = true
}

watch(terminalDrawerVisible, (visible) => {
  if (!visible) {
    terminalDrawerPatch.value = {}
  }
})

watch(riskDrawerVisible, (visible) => {
  if (!visible) {
    riskDrawerChartPreset.value = null
    riskDrawerHandleStatus.value = undefined
  }
})

onMounted(() => {
  if (String(route.query.open_risk_drawer || '') === '1') {
    openRiskDrawerViewAll()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(VirusSummaryCards, {
      onOpenTerminalDrawer: onVirusSummaryOpenTerminal,
      onOpenRiskDrawer: onVirusSummaryOpenRisk
    }),
    _createVNode(_component_el_row, {
      gutter: 16,
      class: "cm-ui-mt16"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(VirusTrendChart, { style: {"height":"380px"} })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(VirusDistributionChart, { style: {"height":"380px"} })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_unref(cmRolePermMapFe).logmanage_virus_stat)
      ? (_openBlock(), _createBlock(Card, {
          key: 0,
          size: "second",
          class: "cm-ui-mt16",
          title: _ctx.$t('loarisTrojanRemover.riskViewPreviewTitle'),
          "body-style": { margin: '-16px' }
        }, {
          titleAfter: _withCtx(() => [
            _createVNode(_component_el_tag, { size: "small" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('common.listPreviewRecent10')), 1)
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(RiskViewTable, {
              ref_key: "riskTableRef",
              ref: riskTableRef,
              onViewAll: openRiskDrawerViewAll
            }, null, 512)
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true),
    _createVNode(Card, {
      size: "second",
      class: "cm-ui-mt16",
      title: _ctx.$t('loarisTrojanRemover.terminalViewPreviewTitle'),
      "body-style": { margin: '-16px' }
    }, {
      titleAfter: _withCtx(() => [
        _createVNode(_component_el_tag, { size: "small" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.listPreviewRecent10')), 1)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(TerminalViewTable, {
          ref_key: "terminalTableRef",
          ref: terminalTableRef,
          onViewAll: openTerminalDrawerViewAll
        }, null, 512)
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_el_drawer, {
      "custom-class": "no-body-margin",
      size: "80%",
      title: _ctx.$t('safeProtectionModule.drawerAllRisks'),
      modelValue: riskDrawerVisible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((riskDrawerVisible).value = $event)),
      "destroy-on-close": "",
      "append-to-body": ""
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(RiskViewTable, {
          key: riskDrawerKey.value,
          viewMode: _unref(TableViewMode).full,
          "preset-from-chart": riskDrawerChartPreset.value,
          "preset-handle-status": riskDrawerHandleStatus.value,
          onUpdatePreview: riskTableRef.value?.getList
        }, null, 8, ["viewMode", "preset-from-chart", "preset-handle-status", "onUpdatePreview"]))
      ]),
      _: 1
    }, 8, ["title", "modelValue"]),
    _createVNode(_component_el_drawer, {
      "custom-class": "no-body-margin",
      size: "80%",
      title: _ctx.$t('safeProtectionModule.drawerAllTerminals'),
      modelValue: terminalDrawerVisible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((terminalDrawerVisible).value = $event)),
      "destroy-on-close": "",
      "append-to-body": ""
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(TerminalViewTable, {
          key: terminalDrawerKey.value,
          viewMode: _unref(TableViewMode).full,
          "initial-query-patch": terminalDrawerPatch.value,
          onUpdatePreview: terminalTableRef.value?.getList
        }, null, 8, ["viewMode", "initial-query-patch", "onUpdatePreview"]))
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ], 64))
}
}

})